
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import TickSection from "../../components/tickSection/TickSection";
import "./homePage.css";
import SkiFocus from "../../assets/skis_pic1.png";
import Skiers1 from '../../assets/skiers1.png';
import Snowflake from "../../assets/snowflakeIcon_red.svg";
import SkiIconsHor from '../../assets/menuicons-all-horizontal.svg'
import SkiWeather from "../../components/skiWeather/SkiWeather";
import { Helmet } from 'react-helmet-async';

const HomePage = () => {
    return (
        <div className="homePage-container">
            <Helmet>
                <title>Alpine Sport i Värmland – Vallning, Slipning & Reparationer</title>
                <meta name="description" content="Välkommen till Alpine Sport i Värmland – din lokala skidtekniker. Vi erbjuder professionell vallning, slipning, skidservice, reparationer och service från vår verkstad i Kristinehamn för att förbättra din skidupplevelse." />
                <meta property="og:title" content="Alpine Sport i Värmland" />
                <meta property="og:description" content="Välkommen till Alpine Sport i Värmland – din lokala skidtekniker. Vi erbjuder professionell vallning, slipning, skidservice, reparationer och service från vår verkstad i Kristinehamn för att förbättra din skidupplevelse." />
                <meta property="og:image" content="%PUBLIC_URL%/socials-image.png" />
                <link rel="icon" href="%PUBLIC_URL%/colours-favicon.png" type="image/png" />
                <meta property="og:url" content="https://alpinesport.se/" />
                <meta property="og:type" content="website" />
                <link rel="canonical" href="https://alpinesport.se/" />
            </Helmet>
            <Header />
            <main>
                <TickSection />
                {/*<Offer />*/}
                <section className="topSection-home">
                    <section className="leftSide-container">
                        <section className="leftSide-article">
                            <img className="snowflake" src={Snowflake} alt="Snowflake icon" />
                            <article className="left-article">
                                <h2 className="home-h2">Kvalité</h2>
                                <p className="black-p">
                                    Skidservice utförd på ett professionellt sätt för hand där vi använder kvalitetsutrustning och flourfri valla.
                                </p>
                            </article>
                        </section>
                        <section className="leftSide-article">
                            <img className="snowflake" src={Snowflake} alt="Snowflake icon" />
                            <article className="left-article">
                                <h2 className="home-h2">Roligare Skidåkning</h2>
                                <p className="black-p">
                                    Skidåkningen blir roligare och du blir en bättre skidåkare med välslipade kanter och vallade skidor.
                                </p>
                            </article>
                        </section>
                        <section className="leftSide-article">
                            <img className="snowflake" src={Snowflake} alt="Snowflake icon" />
                            <article className="left-article">
                                <h2 className="home-h2">Personlig Service</h2>
                                <p className="black-p">
                                    Jag stoltserar med att erbjuda en personlig och professionell servicenivå. Själv har jag åkt skidor i över 40 år och brinner för sporten.
                                </p>
                            </article>
                        </section>
                    </section>
                    <section className="rightSide-container">
                        <img className="skiFocus-img" src={SkiFocus} alt="Skis Focus" />
                    </section>
                </section>

                <section className="skiWeather-container">
                    <SkiWeather />
                </section>

                <section className="topSection-home reverse">
                    <section className="leftSide-container">
                        <article className="bottomSection-topArticle">
                            <img className="skiIcons-horizontal" src={SkiIconsHor} alt="piste icons" />
                            <h2 className="home-h2 h2-centered">De bar o åk´
                                sa Ingemar Stenmark
                            </h2>
                        </article>

                        <article>
                            <p className="black-p">
                                Nja, vet inte riktigt om jag håller med! Utan välservade grejor under fötterna blir det allt annat än att bara åka! Med vassa kanter och välvallade skidor blir skidåkningen betydligt lättare och roligare. Därför bör man serva skidorna regelbundet.<br /><br />Alistair McCann heter jag som driver Alpine Sport i Värmland. Jag är en utbildad skidtekniker och bootfitter och har åkt skidor i över 45 år. Jag älskar att åka överallt på berget och vet att jag kan lita på skidorna i alla lägen då de är servade och anpassade till mig och min åkstil.
                            </p>
                        </article>
                    </section>
                    <section className="rightSide-container">
                        <img className="skiFocus-img" src={Skiers1} alt="skiers in a lift" />
                    </section>
                </section>
            </main>
            <Footer />
        </div>
    );
};

export default HomePage;